import { klona } from 'klona/lite';
import { IContactInformation, ITollServiceProviderWorkingTime } from 'types/apiTypes';

interface IHasContactInformation {
  mainContactInformation?: IContactInformation;
  customerServiceContactInformation?: IContactInformation;
  itContactInformation?: IContactInformation;
  operationalContactInformation?: IContactInformation;
  commercialContactInformation?: IContactInformation;
}

// Data created from the backend may have null values, but the form expects empty strings for workingTimes fields.
const fixWorkingTime = (wt: ITollServiceProviderWorkingTime) => {
  if (wt.startTime === null) wt.startTime = '';
  if (wt.endTime === null) wt.endTime = '';
  if (wt.timeZone === null) wt.timeZone = '';
  if (wt.weekdays === null) wt.weekdays = '';
};

const fixNullValuesOnWorkingTimes = <T extends IHasContactInformation>(data: T): T => {
  const updatedData = klona(data);
  updatedData.mainContactInformation?.workingTimes?.forEach(fixWorkingTime);
  updatedData.customerServiceContactInformation?.workingTimes?.forEach(fixWorkingTime);
  updatedData.itContactInformation?.workingTimes?.forEach(fixWorkingTime);
  updatedData.operationalContactInformation?.workingTimes?.forEach(fixWorkingTime);
  updatedData.commercialContactInformation?.workingTimes?.forEach(fixWorkingTime);
  return updatedData;
};

export default fixNullValuesOnWorkingTimes;
